var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 35.9999C27.941 35.9999 35.9999 27.941 35.9999 17.9999C35.9999 8.05885 27.941 0 17.9999 0C8.05885 0 0 8.05885 0 17.9999C0 27.941 8.05885 35.9999 17.9999 35.9999Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9508 15.9254L18.0001 10.8762L23.0519 15.928L25.9899 12.9899L18.0001 5L10.0128 12.9873L12.9508 15.9254ZM7.93813 15.0617L10.8761 17.9997L7.93798 20.9379L5 17.9999L7.93813 15.0617ZM12.9508 20.0746L18.0001 25.1236L23.0518 20.072L25.9915 23.0086L25.9899 23.0101L18.0001 31L10.0127 23.0127L10.0086 23.0086L12.9508 20.0746ZM31.0003 18.0003L28.0623 20.9382L25.1243 18.0003L28.0623 15.0623L31.0003 18.0003Z",
    fill: "#F0B90B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.98 17.9985H20.9814L18 15.0171L15.0172 17.9999L15.0213 18.0041L18 20.9828L20.9827 17.9999L20.98 17.9985Z",
    fill: "#F0B90B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/Binance.dd6b9c71c517eaa797f732c655a14735.svg";
export { ForwardRef as ReactComponent };